import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export const RECURRING_ITEM_MODAL_ACTION = {
    CURRENT: 'CURRENT',
    HISTORY: 'HISTORY'
} as const;

export type RecurringItemModalAction = typeof RECURRING_ITEM_MODAL_ACTION[keyof typeof RECURRING_ITEM_MODAL_ACTION];

@Component({
    templateUrl: './recurring-item-confirmation-modal.component.html'
})
export class RecurringItemConfirmationModalComponent {
    @Input() daysRemaining: number;

    constructor(public activeModal: NgbActiveModal) {}

    continueToCurrent() {
        this.activeModal.close(RECURRING_ITEM_MODAL_ACTION.CURRENT);
    }

    viewHistory() {
        this.activeModal.close(RECURRING_ITEM_MODAL_ACTION.HISTORY);
    }

    cancel() {
        this.activeModal.dismiss('cancel');
    }
}
